import { render, staticRenderFns } from "./NextTable.vue?vue&type=template&id=4109202a&scoped=true&"
import script from "./NextTable.vue?vue&type=script&lang=js&"
export * from "./NextTable.vue?vue&type=script&lang=js&"
import style0 from "./NextTable.vue?vue&type=style&index=0&id=4109202a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109202a",
  null
  
)

export default component.exports